<template>
  <div>
    <validationObserver ref="addDataForm" tag="form">
      <form>
        <div
          class="form-group row mb-4"
          v-if="userInfo.user_type === 'Operator'"
        >
          <label class="col-form-label col-lg-2">รหัสแบรนด์ (JDA)</label>
          <div class="col-lg-2" v-if="componentModel.id">
            <validationProvider
              v-slot="{ errors }"
              name="JDA"
              :rules="{
                validateMaxInput: [5],
                duplicateName: [isValidate.jda_id, 'มีรหัสนี้อยู่ในระบบแล้ว'],
              }"
            >
              <div class="input-group check-length">
                <input
                  id="input_jda_id"
                  name="input_jda_id"
                  v-model="componentModel.jda_id"
                  class="form-control"
                  type="text"
                  v-bind:min="0"
                  v-bind:max="99999"
                  v-bind:maxlength="5"
                  :class="{
                    'is-invalid': errors && errors.length,
                    'is-valid':
                      !(errors && errors.length) && componentModel.jda_id,
                  }"
                  v-on:keyup="onValidateJDABrandId($event)"
                  @keydown="validateNum($event)"
                />
                <span class="input-validate-length info-icon"
                  >{{
                    componentModel.jda_id ? componentModel.jda_id.length : 0
                  }}/5
                </span>
                <div class="inline-icon">
                  <i
                    class="
                      ml-2
                      mt-2
                      bx bx-info-circle
                      align-middle
                      absolute
                      text-grey
                      f-18
                    "
                    id="tooltip-filter"
                  />
                  <b-tooltip
                    target="tooltip-filter"
                    placement="right"
                    variant="info"
                    >รหัสแบรนด์ต้องตรงกับที่ระบุในระบบ JDA</b-tooltip
                  >
                </div>
              </div>
              <div
                v-if="errors && errors.length"
                class="validate-invalid invaild-left-bottom"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </validationProvider>
          </div>
          <div class="col-lg-2" v-else>
            <validationProvider
              v-slot="{ errors }"
              name="JDA"
              :rules="{
                validateMaxInput: [5],

                duplicateName: [isValidate.jda_id, 'มีรหัสนี้อยู่ในระบบแล้ว'],
              }"
            >
              <div class="input-group check-length">
                <input
                  id="input_jda_id"
                  name="input_jda_id"
                  v-model="componentModel.jda_id"
                  class="form-control"
                  type="text"
                  v-bind:min="0"
                  v-bind:max="99999"
                  v-bind:maxlength="5"
                  :class="{
                    'is-invalid': errors && errors.length,
                    'is-valid':
                      !(errors && errors.length) && componentModel.jda_id,
                  }"
                  v-on:keyup="onValidateJDABrandId($event)"
                  @keydown="validateNum($event)"
                />
                <span class="input-validate-length info-icon"
                  >{{
                    componentModel.jda_id ? componentModel.jda_id.length : 0
                  }}/5
                </span>
                <div class="inline-icon">
                  <i
                    class="
                      ml-2
                      mt-2
                      bx bx-info-circle
                      align-middle
                      absolute
                      text-grey
                      f-18
                    "
                    id="tooltip-filter"
                  />
                  <b-tooltip
                    target="tooltip-filter"
                    placement="right"
                    variant="info"
                    >รหัสแบรนด์ต้องตรงกับที่ระบุในระบบ JDA</b-tooltip
                  >
                </div>
              </div>
              <div
                v-if="errors && errors.length"
                class="validate-invalid invaild-left-bottom"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </validationProvider>
          </div>
        </div>
        <div class="form-group row mb-4">
          <label class="col-form-label col-lg-2">ชื่อแบรนด์</label>
          <div class="col-lg-4">
            <validationProvider
              v-slot="{ errors }"
              name="Thai Name"
              :rules="{
                dynamicRequired: [
                  'กรุณาระบุชื่อแบรนด์เป็นภาษาไทย หากไม่มี กรุณาระบุเป็นภาษาอังกฤษ',
                ],
                duplicateName: [
                  isValidate.display_name_th,
                  'มีรหัสนี้อยู่ในระบบแล้ว',
                ],
                validateWithSpecialCharacters: true,
              }"
            >
              <div class="input-group check-length">
                <span class="input-group-append">
                  <span class="input-group-text">TH</span>
                </span>
                <input
                  id="input_displayname_th"
                  name="input_displayname_th"
                  type="text"
                  class="form-control"
                  maxlength="30"
                  v-model="componentModel.display_name.th"
                  :class="{
                    'is-invalid': errors && errors.length,
                    'is-valid':
                      !(errors && errors.length) &&
                      componentModel.display_name.th,
                  }"
                  v-on:keyup="onValidateDisplaynameTH($event)"
                />
                <span class="input-validate-length"
                  >{{ componentModel.display_name.th.length }}/30
                </span>
              </div>
              <div
                v-if="errors && errors.length"
                class="validate-invalid invaild-left-bottom"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </validationProvider>
          </div>
        </div>
        <div class="form-group row mb-4">
          <label class="col-form-label col-lg-2"></label>
          <div class="col-lg-4">
            <validationProvider
              v-slot="{ errors }"
              name="English Name"
              :rules="{
                dynamicRequired: ['กรุณาระบุชื่อแบรนด์เป็นภาษาอังกฤษ'],
                duplicateName: [
                  isValidate.display_name_en,
                  'มีรหัสนี้อยู่ในระบบแล้ว',
                ],
              }"
            >
              <div class="input-group check-length">
                <span class="input-group-append">
                  <span class="input-group-text">EN</span>
                </span>
                <input
                  id="input_displayname_en"
                  name="input_displayname_en"
                  type="text"
                  class="form-control"
                  maxlength="30"
                  v-model="componentModel.display_name.en"
                  :class="{
                    'is-invalid': errors && errors.length,
                    'is-valid':
                      !(errors && errors.length) &&
                      componentModel.display_name.en,
                  }"
                />
                <span class="input-validate-length">
                  {{ componentModel.display_name.en.length }}/30
                </span>
              </div>
              <div
                v-if="errors && errors.length"
                class="validate-invalid invaild-left-bottom"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </validationProvider>
          </div>
        </div>
        <div class="row form-row form-group">
          <label class="col-form-label col-lg-2">สินค้า Own Brand</label>
          <div class="col-form-label col-lg-8">
            <validationProvider
              v-slot="{ errors }"
              name="Own Brand Flag"
              :rules="{ required: true }"
            >
              <switches
                v-model="componentModel.is_own_brand"
                type-bold="true"
                color="info"
                class="switch-inner-label custom-switches switches-small"
                text-enabled="Yes"
                text-disabled="No"
              ></switches>
              <div v-if="errors && errors.length" class="validate-invalid">
                <span>{{ errors[0] }}</span>
              </div>
            </validationProvider>
          </div>
        </div>
        <div class="form-group row mb-4">
          <label class="col-form-label col-lg-2">สถานะ</label>
          <div class="col-lg-2">
            <basic-select
              :options="optionsStatus"
              :reload="reloadStatusSelector"
              :selected-option="{
                text: componentModel.status,
                value: componentModel.status,
              }"
              @select="onStatusSelector($event)"
              placeholder="ระบุสถานะ"
              v-bind:isError="isValidate.status"
            >
            </basic-select>
          </div>
        </div>

        <div class="form-group row mb-4" v-if="!isShowEditImage">
          <label class="col-form-label col-lg-2">โลโก้แบรนด์</label>
          <div class="col-lg-4">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text bg-transparent"
                  ><i class="bx bxs-folder-open"></i
                ></span>
              </div>
              <b-form-file
                placeholder="Choose file"
                accept="image/*"
                v-on:change="importImage($event)"
                v-model="componentModel.file"
              ></b-form-file>
            </div>
          </div>
          <div class="col-3">
            <div class="card bg-dark-grey">
              <div class="card-body f-12">
                <div>รายละเอียดรูปภาพ</div>
                <ul class="mb-0">
                  <li>ใช้นามสกุล .jpg หรือ .png</li>
                  <li>ความสูงของรูปต้องอยู่ระหว่าง 40 ~ 400 px</li>
                  <li>ความกว้างของรูปต้องอยู่ระหว่าง 116 ~ 400 px</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row mb-4" v-else>
          <label class="col-form-label col-lg-2">โลโก้แบรนด์</label>
          <div class="col-lg-4">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text bg-transparent"
                  ><i class="bx bxs-folder-open"></i
                ></span>
              </div>
              <b-form-file
                placeholder="Choose file"
                accept="image/*"
                v-on:change="importImage($event)"
                v-model="componentModel.file"
              ></b-form-file>
            </div>
          </div>
          <div class="col-3">
            <div class="card bg-dark-grey">
              <div class="card-body f-12">
                <div>รายละเอียดรูปภาพ</div>
                <ul class="mb-0">
                  <li>ใช้นามสกุล .jpg หรือ .png</li>
                  <li>ความสูงของรูปต้องอยู่ระหว่าง 40 ~ 400 px</li>
                  <li>ความกว้างของรูปต้องอยู่ระหว่าง 116 ~ 400 px</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group row ml-100" v-if="isShowEditImage">
          <label class="col-form-label col-lg-2"></label>
          <div class="col-lg-2" v-if="isShowEditImage">
            <div style="position: relative; float: left">
              <!-- <img v-if="isShowEditImage" :src="urlImg" class="rounded" /> -->
              <img
                v-if="isShowEditImage && urlImg !== ''"
                :src="urlImg"
                class="rounded"
              />
              <img
                v-if="
                  urlImg === '' &&
                    componentModel.images &&
                    componentModel.images !== null &&
                    componentModel.images.length > 0
                "
                :src="componentModel.images[0].url"
                class="rounded"
              />

              <div
                class="delete-img-block"
                v-if="
                  (componentModel.images !== null &&
                    componentModel.images.length > 0) ||
                    urlImg !== ''
                "
              >
                <div class="remove-bt" @click="deleteUploadImage">
                  <label class="remove-txt">remove</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </validationObserver>
    <brand-product-relate
      v-if="isShowProductRelate"
      :brandId="componentModel.id"
    ></brand-product-relate>
  </div>
</template>

<script>
import { StatusEnum } from '@/enum/status.enum.js'
import brandService from '@/helpers/service/brand-service'
import Switches from 'vue-switches'
import { BasicSelect } from 'vue-search-select'
import { OptionDropdownStatus } from '@/helpers/utils/status.js'
import BrandProductRelate from '@/components/brand/product-relate'
import filecloudService from '@/helpers/service/filecloud-service'
import { authComputed } from '@/state/helpers'
import { getUserInfo } from '@/helpers/utils/jwt'

export default {
  name: 'BrandDetailEditor',
  components: {
    Switches,
    'basic-select': BasicSelect,
    'brand-product-relate': BrandProductRelate,
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return this.componentModel
      },
    },
    isChanged: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    isShowProductRelate: {
      type: Boolean,
      default: () => {
        return false
      },
    },
  },
  mounted() {
    if (this.isShowProductRelate === false) {
      this.optionsStatus = [
        { text: StatusEnum.ACTIVE, value: StatusEnum.ACTIVE },
        { text: StatusEnum.INACTIVE, value: StatusEnum.INACTIVE },
      ]
    } else {
      this.optionsStatus = [
        { text: StatusEnum.ACTIVE, value: StatusEnum.ACTIVE },
        { text: StatusEnum.INACTIVE, value: StatusEnum.INACTIVE },
        { text: StatusEnum.DELETE, value: StatusEnum.DELETE },
      ]
    }
  },
  data() {
    return {
      componentModel: {
        id: null,
        jda_id: null,
        display_name: {
          th: '',
          en: '',
        },
        status: StatusEnum.ACTIVE,
        is_own_brand: false,
        images: [],
        file: null,
        originalImg: null,
        thumpImg: null,
      },
      urlImg: '',
      componentModelOriginal: {},
      isValidate: {
        display_name_th: false,
        display_name_en: false,
        jda_id: false,
        status: false,
      },
      optionsStatus: [],
      reloadStatusSelector: false,
      isShowEditImage: false,
      canUpdateDeleteStatus: {
        isDelete: false,
        isConfirm: '',
      },
    }
  },
  created: function() {
    if (this.value) {
      this.componentModel = this.value
      this.urlImg = ''
      this.isShowEditImage = true
      this.$set(this.componentModel, 'images', this.value.images)
      this.componentModelOriginal = JSON.parse(JSON.stringify(this.value))
      this.getBrandProductSku()
    }
  },
  computed: {
    ...authComputed,
    userInfo() {
      if (this.getAccessToken !== null) {
        return getUserInfo(this.getAccessToken)
      } else return {}
    },
  },
  watch: {
    value: {
      handler(val) {
        this.componentModel = val

        // this.componentModelOriginal = Object.assign({},val)
      },
      deep: true,
    },
    componentModel: {
      handler(val) {
        if (this.componentModelOriginal) {
          console.log('origi')
          console.log(this.componentModelOriginal)
          console.log('now')

          console.log(this.componentModel)

          if (
            JSON.stringify(this.componentModel) !==
            JSON.stringify(this.componentModelOriginal)
            //|| this.isShowEditImage === true
          )
            this.$emit('update:isChanged', true)
          else this.$emit('update:isChanged', false)
        }
      },
      deep: true,
    },
  },
  methods: {
    async validateNum(e) {
      e = e || window.event
      if (
        (e.key >= 0 && e.key <= 9) ||
        (e.keyCode >= 96 && e.keyCode <= 105) ||
        e.keyCode === 8 ||
        e.keyCode === 9 ||
        e.keyCode === 13 ||
        e.keyCode === 46 ||
        e.keyCode === 37 ||
        e.keyCode === 39
      ) {
        return false
      } else {
        return e.preventDefault()
      }
    },
    async getBrandProductSku() {
      var result = await brandService.getBrandProductSkuListAsync(
        this.componentModel.id
      )
      if (result.status === 200) {
        console.log(result.data.skus)
        var countStatusProductDelete = 0
        var countStatusProductAnother = 0
        result.data.skus.forEach(element => {
          if (element.inventory_status === 'Delete') {
            countStatusProductDelete++
          } else {
            countStatusProductAnother++
          }
        })

        if (countStatusProductDelete === result.data.skus.length) {
          this.canUpdateDeleteStatus = {
            isDelete: true,
            isConfirm: true,
          }
        } else if (
          countStatusProductAnother === result.data.skus.length ||
          (countStatusProductAnother !== 0 && countStatusProductDelete !== 0)
        )
          this.canUpdateDeleteStatus = {
            isDelete: false,
            isConfirm: false,
          }
      }
    },
    async onValidateJDABrandId() {
      if (
        !(
          this.componentModel.jda_id.trim() === '' ||
          this.componentModel.jda_id.trim() === null ||
          this.componentModel.jda_id.trim() === undefined
        )
      ) {
        let params = new URLSearchParams()
        params.append('jdbBrandId', this.componentModel.jda_id.trim())
        if (this.componentModel.id) params.append('id', this.componentModel.id)
        let result = await brandService.headBrandMasterAsync(params)
        if (result.status === 200) {
          this.isValidate.jda_id = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.jda_id = false
        } else {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    async onValidateDisplaynameTH() {
      if (
        !(
          this.componentModel.display_name.th.trim() === '' ||
          this.componentModel.display_name.th.trim() === null ||
          this.componentModel.display_name.th.trim() === undefined
        )
      ) {
        let params = new URLSearchParams()
        params.append('nameTh', this.componentModel.display_name.th.trim())
        if (this.componentModel.id) params.append('id', this.componentModel.id)
        let result = await brandService.headBrandMasterAsync(params)
        if (result.status === 200) {
          this.isValidate.display_name_th = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.display_name_th = false
        } else {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    async onValidateDisplaynameEN() {
      if (
        !(
          this.componentModel.display_name.en.trim() === '' ||
          this.componentModel.display_name.en.trim() === null ||
          this.componentModel.display_name.en.trim() === undefined
        )
      ) {
        let params = new URLSearchParams()
        params.append('nameEn', this.componentModel.display_name.en.trim())
        if (this.componentModel.id) params.append('id', this.componentModel.id)
        let result = await brandService.headBrandMasterAsync(params)
        if (result.status === 200) {
          this.isValidate.display_name_en = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.display_name_en = false
        } else {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    async onStatusSelector(data) {
      this.isValidate.status = false
      this.reloadStatusSelector = false

      if (
        data.text === StatusEnum.DELETE &&
        this.canUpdateDeleteStatus.isDelete &&
        this.canUpdateDeleteStatus.isConfirm
      ) {
        this.$utils
          .confirmAlertDisplay(
            `ข้อมูลที่ถูก Delete จะไม่สามารถนำกลับมาใช้งานใหม่ได้ ต้องการ Delete ข้อมูลนี้ใช่หรือไม่`,
            ''
          )
          .then(result => {
            if (result) this.componentModel.status = data.text ? data.text : ''
          })
      } else if (
        data.text === StatusEnum.DELETE &&
        this.canUpdateDeleteStatus.isDelete &&
        !this.canUpdateDeleteStatus.isConfirm
      ) {
        this.componentModel.status = data.text ? data.text : ''
      } else if (
        data.text === StatusEnum.DELETE &&
        !this.canUpdateDeleteStatus.isDelete
      ) {
        this.$utils.notification(
          'warning',
          'มีสินค้าสถานะพร้อมขายอยู่ในแบรนด์นี้ ไม่สามารถปรับสถานะเป็น Delete ได้',
          2000
        )
      } else {
        this.componentModel.status = data.text ? data.text : ''
      }

      // if (this.isCanUpdateDeleteStatus === false) {
      //   this.$utils.notification(
      //     'warning',
      //     'มีสินค้าสถานะพร้อมขายอยู่ในแบรนด์นี้ ไม่สามารถปรับสถานะเป็น Delete ได้',
      //     2000
      //   )
      // } else {
      //   this.componentModel.status = data.text ? data.text : ''
      // }
    },
    async checkUploadImage() {
      var checkUpload = true
      var isUploadError = false
      if (
        this.componentModel.originalImg !== null &&
        this.componentModel.originalImg !== undefined
      ) {
        let dataOriginal = new FormData()
        dataOriginal.append(
          'file',
          this.componentModel.originalImg,
          `${this.componentModel.id}.jpg`
        )
        var uniq = '' + new Date().getTime()
        dataOriginal.append('bucket', `${process.env.VUE_APP_BUCKET_PIM}`)
        dataOriginal.append('path', `tmp/brands/original`)
        dataOriginal.append('key', `${uniq}.jpg`)
        dataOriginal.append('content_description', `pim-brand`)
        dataOriginal.append('is_upsert', true)
        let resultUploadOriginal = await filecloudService.uploadImageAsync(
          dataOriginal
        )
        if (resultUploadOriginal.status === 201) {
          var imgList = [
            {
              size: 'original',
              url: resultUploadOriginal.data.content_url,
            },
          ]
          this.componentModel.images = imgList
          checkUpload = true
        } else {
          checkUpload = false
          isUploadError = true
          this.$utils.notificationConfirm('error', 'ไม่สามารถ Upload รูปภาพ')
        }
      }
      return checkUpload && isUploadError === false
    },
    importImage(e) {
      var vm = this
      const file = e.target.files[0]
      if (file.type.match(/image.*/)) {
        var reader = new FileReader()
        reader.onload = function(readerEvent) {
          var image = new Image()
          image.onload = function(imageEvent) {
            if (
              40 <= Number(image.height) &&
              Number(image.height) <= 400 &&
              116 <= Number(image.width) &&
              Number(image.width) <= 400
            ) {
              var canvas = document.createElement('canvas')
              canvas.width = image.width
              canvas.height = image.height
              canvas
                .getContext('2d')
                .drawImage(image, 0, 0, image.width, image.height)
              var dataUrl = canvas.toDataURL('image/jpeg')
              var resizedImage = vm.dataURLToBlob(dataUrl)

              vm.urlImg = dataUrl

              // vm.$set(vm.componentModel, 'urlImg', dataUrl)
              vm.componentModel.originalImg = resizedImage
              vm.isShowEditImage = true
            } else {
              vm.componentModel.file = null
              vm.componentModel.originalImg = null
              vm.urlImg = ''
              vm.$utils.notification('error', 'ขนาดรูปไม่เหมาะสม', 2000)
            }
          }
          image.src = readerEvent.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    dataURLToBlob(dataURL) {
      let BASE64_MARKER = ';base64,'
      if (dataURL.indexOf(BASE64_MARKER) == -1) {
        let parts = dataURL.split(',')
        let contentType = parts[0].split(':')[1]
        let raw = parts[1]

        return new Blob([raw], { type: contentType })
      }

      let parts = dataURL.split(BASE64_MARKER)
      let contentType = parts[0].split(':')[1]
      let raw = window.atob(parts[1])
      let rawLength = raw.length

      let uInt8Array = new Uint8Array(rawLength)

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }

      return new Blob([uInt8Array], { type: contentType })
    },
    async deleteUploadImage() {
      this.componentModel.file = []
      this.componentModel.originalImg = null
      this.componentModel.images = []
      this.urlImg = ''
    },
  },
}
</script>
<style scoped>
.ml-100 {
  margin-top: -100px;
}
.image-preview-brand {
  width: 100px;
  height: 100px;
}
.delete-img-block {
  position: absolute;
  bottom: 2px;
  right: 2px;
}
.remove-bt {
  width: 51px;
  height: 17px;
  background-color: #f46a6a;
  border-radius: 8px;
  padding-left: 2px;
}
.remove-txt {
  font-size: 10px;
  color: white;
  margin-left: 3px;
  cursor: pointer;
}
</style>
